// Trip models synced with backend DTOs

export enum TripStatus {
  PLANNED = 'planned',
  IN_PROGRESS = 'inprogress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export enum TripStopType {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}

// Base Trip Query (from TripQry.cs)
export interface TripQry {
  id: string
  tripCode: string
  clusterId: number
  busId: string
  serviceDate: string
  status: string
  plannedDistanceKm: number
  lastRefreshedAt?: string
  startedAt?: string
  completedAt?: string
  createdAt: string
  updatedAt?: string
}

// Get Trip Query Response (from GetTripQry.cs)
export interface GetTripQry extends TripQry {
  clusterNameEn: string
  clusterNameAr: string
  busNameEn: string
  busNameAr: string
  hardFlag: boolean
  totalTickets: number
  totalTicketCompleted: number
  housingNameEn: string
  housingNameAr: string
}

export interface GetTripResponse {
  totalTrips: number
  lstTrips: GetTripQry[]
}

// Trip Log for progression tracking
export interface TripLog {
  id: string
  status: string
  timestamp: string
  notes?: string
}

// Get Trip Ticket Query Response (from GetTripTicketQry.cs)

export interface TicketLog {
  dateTime: string // "2026-07-03T11:48:23.71+00:00"
  event: string
}

export interface GetTripTicketQry {
  id: string
  tripId: string
  ticketId: string
  sequence: number
  stopType: TripStopType
  plannedArrivalAt: string
  actualArrivalAt?: string
  status: string
  serviceNameEn: string
  serviceNameAr: string
  customerName: string
  customerPhoneNumber: string
  customerLat?: number
  customerLng?: number
  customerLocationRemarks: string
  scheduledVisitDateTime?: string
  scheduledVisitEndDateTime?: string
  progression: TripLog[]
  isShowLog?: boolean
  routed: string
  readyForPickUp: string
  subServiceNameEn: string
  subServiceNameAr: string
  deliveryStart: string
  deliveryEnd: string
  visitDuration: number
  durationContract: string
  durationContractUnitNameAr: string
  durationContractUnitNameEn: string
  customerPhone?: string
  clusterNameEn?: string
  clusterNameAr?: string
  booked?: string
  numberOfWorker?: number
  logs?: TicketLog[]
}

// Request DTOs

// Trip Command (from TripCmd.cs)
export interface TripCmd {
  serviceDate: string
  status: string // Required by backend, use empty string if no filter
  clusterId?: number
  search: string // Required by backend, use empty string if no filter
  clientTimeZone?: number
  language: string
  cityId?: number
  housingId?: number
}

export interface GetUnassignedTicketsCmd {
  clientTimeZone?: number
}

// Result of GET /api/v1/trip/check-enabled-manual-routing
export interface CheckEnabledManualRoutingQry {
  isEnabled: boolean
  unassignedTicket: number
}

// Get Manual Routing Cooldown Query (from get-manual-routing-cooldown)
export interface ManualRoutingCooldownQry {
  isOnCooldown: boolean
  cooldownUntil: string | null
  remainingSeconds: number
  unassignedTicket: number
}

// Get Trip Tickets Command (from GetTripTicketsCmd.cs)
export interface GetTripTicketsCmd {
  tripId: string
  search: string
  language: string
  clientTimeZone?: number
}

// UI-specific models for display
export interface TripDisplayModel extends GetTripQry {
  ticketList?: GetTripTicketQry[]
  routesRefreshed?: string
  routesRefreshedTime?: string
}

// Filter options for UI
export interface TripFilterOptions {
  serviceDate: Date | null
  status?: string
  clusterId?: number
  search?: string
  language: string
  clientTimeZone: number
  cityId?: number,
  housingId?: number,
}

export interface TripClusterModel {
  nameEn: string
  nameAr: string
  id: number
  isActive: boolean
}
